import rootReducer from "../reducers/index";
import thunkMiddleware from "redux-thunk";
import { createBrowserHistory } from 'history'
import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'connected-react-router'

export const history = createBrowserHistory()

let store = '';

export default function configureStore(preloadedState) {
    store = createStore(
      rootReducer(history), // root reducer with router state
      preloadedState,
      compose(
        applyMiddleware(
          routerMiddleware(history), // for dispatching history actions
          thunkMiddleware
        )
      ),
    )
    return store
  }

export const getStore =() => store;